import React from 'react';
import './style.scss';

export interface ProgressBarProps {
  proc: number;
  color?: string;
  height?: string;
  className?: string;
  style?: React.CSSProperties;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  proc,
  color = 'support',
  height = '.75rem',
  className = '',
  style,
}) => (
  <div
    className={`progress-bar ${className}`}
    style={{ height, ...style }}
  >
    <div
      className={`progress-value ${color}`}
      style={{ height, width: `${proc}%` }}
    />
  </div>
);

export default ProgressBar;
